import React from "react";

export const TextInputs = props => {
    const {value, setAnswer} = props;

    return <div className="amsh-textinputs">
        <input type="text" value={value} onChange={e => setAnswer(e.target.value)}/>
    </div>
}
